// CookieConsent.js
import { useState, useEffect } from 'react';
import '../styles/CookieConsent.css';
import { useTranslation } from 'react-i18next';

const CONSENT_KEY = 'zeldle-cookie-consent';

function loadMonetagScripts() {
  const s1 = document.createElement('script');
  s1.dataset.zone = '11514609';
  s1.src = 'https://nap5k.com/tag.min.js';
  document.body.appendChild(s1);

  /*const s2 = document.createElement('script');
  s2.dataset.zone = '11514610';
  s2.src = 'https://n6wxm.com/vignette.min.js';
  document.body.appendChild(s2);*/
}

function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === 'accepted') {
      loadMonetagScripts();
    } else if (consent === null) {
      setVisible(true);
    }
    // si 'refused', on ne fait rien
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    loadMonetagScripts();
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem(CONSENT_KEY, 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <p>
        {t('cookieconsent.message')}{' '}
        <a href="/privacy">{t('cookieconsent.link')}</a>
      </p>
      <div className="cookie-consent-buttons">
        <button onClick={handleRefuse} className="cookie-refuse">{t('cookieconsent.refuse')}</button>
        <button onClick={handleAccept} className="cookie-accept">{t('cookieconsent.accept')}</button>
      </div>
    </div>
  );
}

export default CookieConsent;